<!--供应商补遗公告列表-->
<template>
  <div class="template-detail-body">
    <div class="ccui-app-container-detail2">
      <div class="ccui-app-container-detail-body">
        <div style="margin-bottom:10px" v-if="isPassFlag">
          <!-- 淘汰 已不能查看 -->
          <el-alert
            class="alertColor"
            :title="$t('page.content.UnableSee')"
            type="warning"
            :closable="false"
            show-icon
          >
          </el-alert>
        </div>
        <!-- 公告列表 -->
        <el-group-title :title="$t('page.content.NoticesList')" v-else>
          <template slot="groupTitle">
            <el-table
              :data="tableData"
              border
              :empty-text="`${$t('page.content.noData')}`"
            >
              <!-- 序号 -->
              <el-table-column
                type="index"
                :label="$t('page.content.No')"
                width="55"
              ></el-table-column>
              <!-- 类型 -->
              <el-table-column
                prop="addStepCodeStr"
                :label="$t('page.content.type')"
                min-width="120"
              ></el-table-column>
              <!-- 标题 -->
              <el-table-column
                prop="noticeTitle"
                :label="$t('page.content.Title')"
                min-width="120"
                show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  <span class="heighlight" @click="handleView(row)">{{
                    row.noticeTitle
                  }}</span>
                </template>
              </el-table-column>
              <!-- 环节 -->
              <el-table-column
                prop="addStepCodeStr"
                :label="$t('page.content.Stage')"
                min-width="120"
              ></el-table-column>
              <!-- 发布时间 -->
              <el-table-column
                prop="createTime"
                :label="$t('page.content.Publish')"
                min-width="170"
              >
                <template slot-scope="{ row }">
                  <span>
                    {{ row.createTime | formatTime1 }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-group-title>
      </div>
    </div>
  </div>
</template>
<script>
import {
  qrySupplementNoticeList,
  qrySupPreqtion
} from "@/app/myProjects/api/myProjects.js";
export default {
  components: {},
  data() {
    return {
      tableData: [],
      agentId: "",
      schemeId: "",
      isPassFlag: false //1：通过 0或者空：淘汰
    };
  },
  created() {},
  async mounted() {
    /**梁青竹临时处理Begin**/
    let supplierFlag = sessionStorage.getItem("supplierFlag");
    if (this.$route_query.supplierFlag) {
      this.$store.dispatch("setSupplierFlag", supplierFlag);
      sessionStorage.setItem("supplierFlag", this.$route_query.supplierFlag);
    } else if (supplierFlag) {
      this.$store.dispatch("setSupplierFlag", supplierFlag);
    }
    /**梁青竹临时处理End**/

    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");

    let params = {
      agentId: this.agentId,
      supCode: sessionStorage.getItem("supCode"),
      schemeId: this.schemeId,
      isShowPageLoading: true
    };

    let res = (await qrySupPreqtion(params)).data.data;
    let eliminateObj = res.sscSupPreqtionBO;
    if (eliminateObj == null) {
      this.isPassFlag = false;
    } else {
      let eliminate = res.sscSupPreqtionBO.passFlag;
      let preStatus = res.sscSupPreqtionBO.preStatus; // =2 表示资格审定已经结束
      this.isPassFlag =
        eliminate === "0" || (eliminate === "" && preStatus === "2");
    }

    if (!this.isPassFlag) {
      this.getSupplementNoticeList();
    }
  },
  methods: {
    getSupplementNoticeList() {
      let obj = {
        isShowTag: false,
        isShowexeTime: true,
        isShowLeftTime: false,
        isShowCouTime: false
      };
      this.$store.commit("edit", obj);
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { purStep: this.$route_query.purStep },
        { isShowPageLoading: true }
      );
      qrySupplementNoticeList(param).then(res => {
        if (res) {
          this.tableData = res.data.data;
        }
      });
    },
    handleView(row) {
      this.$router.push({
        path: "addendumAnnouncementDetails",
        query: {
          noticeId: row.noticeId,
          supProcessId: this.$route_query.supProcessId,
          purStep: this.$route_query.purStep,
          schemeId: this.$route_query.schemeId,
          a: this.$route_query.a
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-table__row {
  line-height: 36px;
  height: 36px;
}
</style>
